import { RootObject } from '../types/customcad';

import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';

export const useCustomCAD = (eotId?: string | null) => {
    return useQuery<RootObject, Error>(
        ['eot', eotId],
        async () => {
            const jsonResponse = await request({
                endpoint: 'cad/get-by-location',
                data: {
                    id: eotId,
                },
            });

            if (!jsonResponse.success) {
                throw new Error(jsonResponse.data.Message || 'Something went wrong');
            }

            return jsonResponse;
        },
        {
            enabled: !!eotId,
    refetchOnWindowFocus: false,  

        }
    );
};
